import { createStore } from 'owa-satcheljs';
import type { AccountAndCoprincipalSourceId, AccountSourceList } from './schema/AccountSourceList';

const defaultStore: AccountSourceList = {
    globalSettingsSourceId: '',
    sourcesBySourceId: new Map<string, AccountAndCoprincipalSourceId>(),
    nextAccountSessionAtom: 0,
    sources: [],
    removedAccounts: [],
    licensingIdentities: [],
};

const defaultExport: () => AccountSourceList = createStore<AccountSourceList>(
    'AccountSourceList',
    defaultStore
);
export default defaultExport;
